import React from "react";
import PdfViewer from "../comman/PdfViewer";
import { onboardingDocs } from "../consfig";

const OnboardingB = () => {
  const pdfUrl = onboardingDocs.b2b.onBoardHotel;
  return <PdfViewer pdfFile={pdfUrl} />;
};

export default OnboardingB;
